import TemplateList from './TemplateList';
import MessageList from './MessageList';

export default {
  TemplateList,
  MessageList,
};
